var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{
      [_vm.$style.progressContainer]: _vm.isFailed || _vm.isCompleted,
      [_vm.$style.failed]: _vm.isFailed,
      [_vm.$style.completed]:_vm.isCompleted,
      [_vm.$style.other]: !_vm.isFailed && !_vm.isCompleted,
    }},[_vm._v(" "+_vm._s(_vm.reportProgress)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }